import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { KundenArtsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [KundenArtsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class KundenArtsServiceModule {}
